import { EmptyState } from '@cockpit/ui';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-xl p-10">
      <EmptyState title="Page introuvable" action={<Link to="/">Revenir à l’accueil</Link>}>
        L’adresse demandée n’existe pas ou a été déplacée.
      </EmptyState>
    </div>
  );
}
